import { History } from 'history'
import * as React from 'react'
import { hot } from 'react-hot-loader'
import { Provider } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { ConnectedRouter } from 'react-router-redux'
import { Store } from 'redux'

import { IRootState } from '../common/reducers'
import { newRoutes, oldRoutes } from '../common/routes'
import { logError } from '../common/utils/errors'
import { hasFeature } from '../common/utils/features'
import RouteHashScroll from './components/routeHashScroll'
import PendingNavDataLoaderContainer from './containers/pendingNavDataLoaderContainer'

interface IProps {
  store: Store<IRootState>
  history: History
}

interface IState {
  hasError: boolean
  hasMounted: boolean
}

class App extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      hasError: false,
      hasMounted: false
    }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ hasError: true })
    // send this to rollbar later
    logError(error)
  }

  public componentDidMount() {
    // used for the purpose of smoke tests to ensure
    // our bundle is functional
    this.setState({ hasMounted: true })
  }

  public render() {
    const { store, history } = this.props
    const {
      common: { currentSite },
      experiments,
      router: { location }
    } = store.getState()
    const routes = hasFeature('routes:new', currentSite, location, experiments)
      ? newRoutes
      : oldRoutes

    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <RouteHashScroll location={location}>
            <PendingNavDataLoaderContainer store={store} routes={routes}>
              {renderRoutes(routes)}
              {this.state.hasMounted ? <span data-mounted="mounted" /> : null}
            </PendingNavDataLoaderContainer>
          </RouteHashScroll>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default hot(module)(App)
